import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useInvalidateProjectTagsQuery } from './useInvalidateTagsQuery';

type MutationParams = {
  tagId: number;
  hidden: boolean;
  parentId: number | null;
};

export const useToggleTagVisibilityMutation = (projectId: number) => {
  const apiClient = useChatApiClient();
  const invalidateTagsQuery = useInvalidateProjectTagsQuery(projectId);

  return useMutation({
    mutationKey: ['toggle-project-tag-visibility', projectId],
    mutationFn: ({ tagId, hidden, parentId }: MutationParams) => {
      return apiClient.projects.updateProjectTag({
        projectId,
        tagId,
        updates: { hidden, parentId },
      });
    },
    onSuccess: () => {
      invalidateTagsQuery();
    },
  });
};
